<template>
  <div class="scgd_content">
    <el-row type="flex" justify="space-around" style="width: 100%; height: 49%">
      <el-col :span="12">
        <div class="scgd_title"><span>本月订单统计</span></div>
        <div class="scgd_block">
          <div class="scgd_block_single">
            <img :src="imgs.img01" alt="" width="67" height="57" />
            <div class="scgd_block_right">
              <span class="scgd_text_desc">本月计划订单数</span>
              <div class="scgd_line"></div>
              <div class="scgd_text">
                <countTo
                  class="scgd_count"
                  :startVal="0"
                  :endVal="form.planNum"
                  :duration="3000"
                ></countTo
                ><span class="scgd_unit">个</span>
              </div>
            </div>
          </div>
          <div class="scgd_block_single">
            <img :src="imgs.img02" alt="" width="67" height="57" />
            <div class="scgd_block_right">
              <span class="scgd_text_desc">本月完成订单数</span>
              <div class="scgd_line"></div>
              <div class="scgd_text">
                <countTo
                  class="scgd_count"
                  :startVal="0"
                  :endVal="form.completionNum"
                  :duration="3000"
                ></countTo>
                <span class="scgd_unit">个</span>
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="scgd_title"><span>按时交付率</span></div>
        <div
          id="chart01"
          ref="chartRef"
          style="width: 100%; height: 100px"
        ></div>
      </el-col>
    </el-row>
    <el-row style="width: 100%; height: 50%">
      <el-col :span="24">
        <div class="scgd_title"><span>工单进度</span></div>
      </el-col>
      <el-col :span="24">
        <el-table
          ref="scroll_Table1"
          class="scgd_table"
          :data="tableData"
          stripe
          style="width: 100%"
          height="100"
          @mouseenter.native="autoScroll(true)"
          @mouseleave.native="autoScroll(false)"
        >
          <el-table-column prop="workorderCode" label="工单编码" align="center">
          </el-table-column>
          <el-table-column prop="sourceCode" label="订单编号" align="center">
          </el-table-column>
          <el-table-column prop="clientName" label="客户名称" align="center">
          </el-table-column>
          <el-table-column prop="productCode" label="产品编号" align="center">
          </el-table-column>
          <el-table-column prop="productName" label="产品名称" align="center">
          </el-table-column>
          <el-table-column prop="productSpc" label="规格型号" align="center">
          </el-table-column>
          <el-table-column prop="unitOfMeasure" label="单位" align="center">
          </el-table-column>
          <el-table-column prop="attr1" label="生产进度" align="center">
          </el-table-column>
          <el-table-column prop="requestDate" label="需求日期" align="center">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import * as echarts from 'echarts'
import countTo from 'vue-count-to'
import { getWorkorderLargeScreenCount, getWorkorderLargeScreenList } from '@/api/index'
export default {
  components: {
    countTo
  },
  data () {
    return {
      imgs: {
        img01: require('@/assets/imgs/icon01.png'),
        img02: require('@/assets/imgs/icon.png'),
      },
      form: {
        planNum: 0,
        completionNum: 0
      },
      rateList: [],
      tableData: [],
    }
  },
  mounted () {

    this.getWorkorderLargeScreenCounts()
    this.getWorkorderLargeScreenLists()
    this.autoScroll()
  },
  beforeDestroy () {
    this.autoScroll(true)
  },
  methods: {
    // 设置自动滚动
    autoScroll (stop) {
      const table = this.$refs.scroll_Table1
      // 拿到表格中承载数据的div元素
      const divData = table.$refs.bodyWrapper
      // 拿到元素后，对元素进行定时增加距离顶部距离，实现滚动效果(此配置为每100毫秒移动1像素)
      if (stop) {
        //再通过事件监听，监听到 组件销毁 后，再执行关闭计时器。
        window.clearInterval(this.scrolltimer)
      } else {
        this.scrolltimer = window.setInterval(() => {
          // 元素自增距离顶部1像素
          divData.scrollTop += 1
          // 判断元素是否滚动到底部(可视高度+距离顶部=整个高度)
          if (divData.clientHeight + divData.scrollTop >= divData.scrollHeight) {
            // 重置table距离顶部距离
            divData.scrollTop = 0
            // 重置table距离顶部距离。值=(滚动到底部时，距离顶部的大小) - 整个高度/2
            // divData.scrollTop = divData.scrollTop - divData.scrollHeight / 2
          }
        }, 100) // 滚动速度
      }
    },
    async getWorkorderLargeScreenCounts () {
      let result = await getWorkorderLargeScreenCount({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this, 'form', result.data)
        this.$set(this, 'rateList', result.data.rateList)
        this.setOpenCloseCharts()
      }
    },
    async getWorkorderLargeScreenLists () {
      let result = await getWorkorderLargeScreenList({})
      console.log(result)
      if (result.code == 200) {
        this.$set(this, 'tableData', result.data)
      }
    },
    setOpenCloseCharts () {
      const theEcharts = echarts.init(this.$refs.chartRef, 'dark');
      const options = {
        // title: {
        //   text: '按时交付率',
        //   left: 'center'
        // },
        grid: {
          left: '0%',    // 去除左侧间距
          right: '0%',   // 去除右侧间距
          bottom: '0%',  // 去除底部间距
          top: '30%',     // 去除顶部间距
          containLabel: true // 如果使用 `containLabel: true`，则会根据标签大小自动调整间距，保证标签内容不被裁剪
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          // top: 30,
          data: ['完成数量', '按时完成数量']
        },
        xAxis: [
          {
            type: 'category',
            data: this.rateList.map(item => item.currentMonth),
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '数量(个)',
            min: 0,
            max: 20,
            interval: 5,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '比率(%)',
            min: 0,
            max: 30,
            interval: 10,
            axisLabel: {
              formatter: '{value}'
            }
          }
        ],
        series: [
          {
            name: '完成数量',
            type: 'bar',
            barWidth: 10,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: this.rateList.map(item => item.completionNum)
          },
          {
            name: '按时完成数量',
            type: 'bar',
            barWidth: 10,
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: this.rateList.map(item => item.onTimeCompleteNum)
          }
        ]
      }
      // 渲染图表
      theEcharts.setOption(options)
    },
  }
}
</script>
<style lang="scss" scoped>
.scgd_content {
  .scgd_title {
    width: 100%;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #ffffff;
    text-align: center;
    padding-bottom: 5px;
  }
  .scgd_block {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-around;
    align-content: center;
    .scgd_block_single {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .scgd_block_right {
        height: 60%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        .scgd_text_desc {
          font-family: Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
        }
        .scgd_text {
          width: 80%;
          display: flex;
          justify-content: space-between;
        }
        .scgd_line {
          width: 90%;
          height: 1px;
          background: #454884;
          border: 1px solid #ffffff;
          opacity: 0.3;
        }
        .scgd_text {
          .scgd_count {
            font-family: DIN;
            font-weight: bold;
            font-size: 22px;
            color: #2ce2d3;
          }
          .scgd_unit {
            font-family: Source Han Sans CN;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
          }
        }
      }
    }
  }
}
</style>
<style lang="scss">
.scgd_table .el-table__cell {
  padding: 2px 0;
}
</style>